module.exports = __webpack_public_path__ + "static/publish_scoping_report-9c9924c4df02e1d1d1a89663e39ccac4.gif";